import request from '@/utils/request'

export function getExportFile(data) {
  return request({
    url: 'api/v1/export-file/list',
    method: 'post',
    data: data
  })
}

